/**
 * formikContext 및 entityContext 를 노출하여 간단하게 EntityEditor 내에서 동작하는 컴포넌트를
 * 만들 수 있도록 하는 Helper Component
 */
import { selectKeyPath } from '@odc/odbelt'
import { useFormikContext } from 'formik'
import React from 'react'
import { useODEntityContext } from '../../..'
export var ODEntityRaw = function (props) {
  var name = props.name,
    keyPath = props.keyPath,
    render = props.render
  var formikContext = useFormikContext()
  var entityContext = useODEntityContext()
  if (!formikContext) {
    return null
  }
  var errors = formikContext.errors,
    touched = formikContext.touched,
    handleChange = formikContext.handleChange,
    values = formikContext.values,
    isSubmitting = formikContext.isSubmitting
  // @ts-ignore
  var value = selectKeyPath(keyPath)(values, '')
  // @ts-ignore
  var error = errors[name]
  // @ts-ignore
  var touchedElement = !!touched[name]
  var rendered = render({
    value: value,
    error: error,
    handleChange: handleChange,
    touched: touchedElement,
    isSubmitting: isSubmitting,
    formikContext: formikContext,
    entityContext: entityContext,
  })
  return React.createElement(React.Fragment, null, rendered)
}
//# sourceMappingURL=ODEntityRaw.js.map
